export const EXPERIENCE_BY_PATH_ENDPOINT = '/graphql/execute.json/yme/getDestinationByPath;path=';
export const PARTNER_LOGO_KEY = 'partnerLogo';
export const PRIMARY_IMAGE_KEY = 'primaryImage';
